// NOTE font sizes: the header setting "font size" (workorder-font-size-setting-2026-09-14) multiplies the
// component pixel sizes with the CSS custom properties --whoo-fs-title|subtitle|details|text. A theme that
// sets a `font-size` here overrides that calc() via ngStyle - write it as
// `'font-size': 'calc(Xpx * var(--whoo-fs-<group>, 1))'` so the setting keeps working for that theme.
export type InvitationStyleConfig = {

    leftStyle?: {
        backgroundContainerBigScreen?: any;
        backgroundContainerSmallScreen?: any;
        contentContainerBigScreen?: any;
        contentContainerSmallScreen?: any;
        backgroundBox?: any;
        pollTitle?: any;
        pollDescription?: any;
        whenBox?: any;
        whenTitle?: any;
        date?: any;
        time?: any;
        whereBox?: any;
        whereTitle?: any;
        respondTillStamp?: any;
        respondTillDate?: any;
        respondTillTitle?: any;
        commentsBox?: any;
        commentsTitle?: any;
    }
}

export const invitationStyleMap = new Map<string, InvitationStyleConfig>([//

    ['invite-background-only', {
        leftStyle: {
            backgroundContainerBigScreen: {
            },
            contentContainerBigScreen: {
                'backdrop-filter': 'none',
            },
            contentContainerSmallScreen: {
                'backdrop-filter': 'none',
            },
        },
    }],
    ['invite-blur-2', {
        leftStyle: {
            contentContainerBigScreen: {
                'backdrop-filter': 'blur(2px)',
            },
            contentContainerSmallScreen: {
                'backdrop-filter': 'blur(2px)',
            }
        }
    }],
    ['invite-blur-8', {
        leftStyle: {
            contentContainerBigScreen: {
                'backdrop-filter': 'blur(8px)',
            },

            contentContainerSmallScreen: {
                'backdrop-filter': 'blur(8px)',
            }
        }
    }],
    ['invite-blur-12', {
        leftStyle: {
            contentContainerBigScreen: {
                'backdrop-filter': 'blur(12px)',
            },
            contentContainerSmallScreen: {
                'backdrop-filter': 'blur(12px)',
            }
        }
    }],

    ['invite-background-white-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(255, 255, 255, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(255, 255, 255, 0.4)',
            }
        },
    }],
    ['invite-background-black-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(0, 0, 0, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(0, 0, 0, 0.4)',
            }
        },
    }],
    ['invite-background-red-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(220, 53, 69, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(220, 53, 69, 0.4)',
            }
        },
    }],
    ['invite-background-blue-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(0, 123, 255, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(0, 123, 255, 0.4)',
            }
        },
    }],
    ['invite-background-green-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(40, 167, 69, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(40, 167, 69, 0.4)',
            }
        },
    }],
    ['invite-background-yellow-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(255, 193, 7, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(255, 193, 7, 0.4)',
            }
        },
    }],
    ['invite-background-purple-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(128, 0, 128, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(128, 0, 128, 0.4)',
            }
        },
    }],
    ['invite-glass-light', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(255, 255, 255, 0.3)',
                'backdrop-filter': 'blur(10px)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(255, 255, 255, 0.3)',
                'backdrop-filter': 'blur(10px)',
            }
        },
    }],
    ['invite-glass-dark', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(0, 0, 0, 0.3)',
                'backdrop-filter': 'blur(10px)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(0, 0, 0, 0.3)',
                'backdrop-filter': 'blur(10px)',
            }
        },
    }],
    ['invite-gradient-bottom-dark', {
        leftStyle: {
            contentContainerBigScreen: {
                'background': 'linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6))',
            },
            contentContainerSmallScreen: {
                'background': 'linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6))',
            }
        },
    }],
    ['invite-background-warm-transparent', {
        leftStyle: {
            contentContainerBigScreen: {
                'background-color': 'rgba(245, 235, 220, 0.6)',
            },
            contentContainerSmallScreen: {
                'background-color': 'rgba(245, 235, 220, 0.4)',
            }
        },
    }],
])



